import StockAdjustment from '@/models/StockAdjustment/StockAdjustment';

export default class StockAdjustmentFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.stockAdjustmentNumber = '';
		this.stockAdjustmentDateFrom = '';
		this.stockAdjustmentDateTo = '';
		this.stockAdjustmentTypeId  = '';
		this.stockAdjustmentTypeName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			stockAdjustmentNumber : '0',
			stockAdjustmentDateFrom : '0',
			stockAdjustmentDateTo : '0',
			stockAdjustmentTypeId : '0',
			stockAdjustmentTypeName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}